import { React, useEffect, useState } from "react";
import { AiFillHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { FaEye, FaWhatsapp } from "react-icons/fa";
import { motion } from "framer-motion";
import Ratings from "../Ratings";
import {
  add_to_card,
  messageClear,
  add_to_wishlist,
} from "../../store/reducers/cardReducer";
const ShopProducts = ({ styles, products, seller }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { successMessage, errorMessage } = useSelector((state) => state.card);
  const [hoveredCard, setHoveredCard] = useState(null);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [errorMessage, dispatch, successMessage]);
  const add_card = (id) => {
    if (userInfo) {
      dispatch(
        add_to_card({
          userId: userInfo.id,
          quantity: 1,
          productId: id,
        }),
      );
    } else {
      navigate("/login");
    }
  };

  const add_wishlist = (pro) => {
    if (userInfo) {
      dispatch(
        add_to_wishlist({
          userId: userInfo.id,
          productId: pro._id,
          name: pro.name,
          price: pro.price,
          image: pro.images[0],
          discount: pro.discount,
          rating: pro.rating,
          slug: pro.slug,
        }),
      );
    } else {
      navigate("/login");
    }
  };
  return (
    <div className="w-full grid grid-cols-3 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
      {products.map((p, i) => (
        <motion.div
          key={i}
          className="hover:border hover:border-secondary/20 group transition-all duration-300 hover:bg-card rounded-3xl hover:shadow-sm hover:-mt-1 cursor-pointer"
          onMouseEnter={() => setHoveredCard(i)}
          onMouseLeave={() => setHoveredCard(null)}
          onClick={() => {
            if (window.innerWidth < 768) return; // mobile
            navigate(`/product/details/${p.slug}`);
          }}
          initial={{ opacity: 0.9, scale: 1 }}
          animate={{
            opacity: hoveredCard === i ? 1 : 0.9,
            scale: hoveredCard === i ? 1.02 : 1,
            transition: { duration: 0.3 },
          }}
        >
          <div className="relative transition-opacity duration-500 ease-in-out overflow-hidden">
            {p.discount ? (
              <div className="flex justify-center items-center absolute text-white w-[38px] h-[38px] rounded-full bg-red-500 font-semibold text-xs left-2 top-2">
                -{p.discount}%
              </div>
            ) : (
              ""
            )}
            <img
              className="sm:w-full w-full rounded-3xl group-hover:rounded-b-none transition-all duration-200 h-[240px] object-cover"
              src={(hoveredCard === i && p.images[1]) ? p.images[1] : p.images[0]}
              alt="product"
            />
            <ul className="flex transition-all duration-500 -bottom-11 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
              <li
                onClick={(e) => {
                  e.stopPropagation();
                  add_wishlist(p);
                }}
                className="w-[44px] h-[44px] cursor-pointer bg-card text-secondary flex justify-center items-center rounded-full hover:bg-secondary hover:text-card hover:rotate-[720deg] transition-all"
              >
                <AiFillHeart className="text-xl" />
              </li>
              <Link
                onClick={(e) => e.stopPropagation()}
                to={`/product/details/${p.slug}`}
                className="w-[44px] h-[44px] cursor-pointer bg-card text-secondary flex justify-center items-center rounded-full hover:bg-secondary hover:text-card hover:rotate-[720deg] transition-all"
              >
                <FaEye className="text-xl" />
              </Link>
              <li
                onClick={(e) => {
                  e.stopPropagation();
                  add_card(p._id);
                }}
                className="w-[44px] h-[44px] cursor-pointer bg-card text-secondary flex justify-center items-center rounded-full hover:bg-secondary hover:text-card hover:rotate-[720deg] transition-all"
              >
                <AiOutlineShoppingCart className="text-xl" />
              </li>
              {(p.sellerId?.whatsappNumber || seller?.whatsappNumber) && (
                 <a
                 onClick={(e) => e.stopPropagation()}
                 href={`https://wa.me/${p.sellerId?.whatsappNumber || seller.whatsappNumber}?text=${encodeURIComponent(
                   `Hello, I want to buy this product:\n\n*Name:* ${p.name}\n*SKU:* ${p.sku || 'N/A'}\n*Price:* Rs.${p.discount > 0 ? p.price - Math.floor((p.price * p.discount) / 100) : p.price}\n*Link:* ${window.location.origin}/product/details/${p.slug}`
                 )}`}
                 target="_blank"
                 rel="noopener noreferrer"
                 className="w-[44px] h-[44px] cursor-pointer bg-card text-green-500 flex justify-center items-center rounded-full hover:bg-green-500 hover:text-white hover:rotate-[720deg] transition-all"
               >
                 <FaWhatsapp className="text-xl" />
               </a>
              )}
            </ul>
          </div>
          <div className="py-3 text-primary px-2">
            <h2 className="text-lg font-medium">{p.name}</h2>
            <div className="flex justify-start items-center gap-3 text-xl mt-1">
              {p.discount !== 0 ? (
                <>
                  <p className="line-through">Rs.{p.price}</p>
                  <p className="font-medium">
                    Rs.
                    {p.price - Math.floor((p.price * p.discount) / 100)}{" "}
                  </p>
                </>
              ) : (
                <p className="font-medium">Rs.{p.price}</p>
              )}
              <div className="flex">
                <Ratings ratings={p.rating} />
              </div>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default ShopProducts;
